import { OriginalEntityValue } from "./original-entity-value";

export class Auditable {
  public CreateDate: Date;
  public CreateUser: number;
  public UpdateDate?: Date;
  public UpdateUser?: number;
  public OriginalEntityValue: OriginalEntityValue;
}
